/* tslint:disable */
import {
  Library,
  Tag
} from '../index';

declare var Object: any;
export interface FeedInterface {
  "id": string;
  "FeedType": Array<any>;
  "Url": string;
  "Description"?: string;
  "Username"?: string;
  "Password"?: string;
  "UpdateInterval": number;
  "GetPreviousTime": number;
  "GetPreviousItems": number;
  "Metadata"?: any;
  "libraryId"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  library?: Library;
  tags?: Tag[];
}

export class Feed implements FeedInterface {
  "id": string;
  "FeedType": Array<any>;
  "Url": string;
  "Description": string;
  "Username": string;
  "Password": string;
  "UpdateInterval": number;
  "GetPreviousTime": number;
  "GetPreviousItems": number;
  "Metadata": any;
  "libraryId": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  library: Library;
  tags: Tag[];
  constructor(data?: FeedInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Feed`.
   */
  public static getModelName() {
    return "Feed";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Feed for dynamic purposes.
  **/
  public static factory(data: FeedInterface): Feed{
    return new Feed(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Feed',
      plural: 'Feeds',
      path: 'Feeds',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "FeedType": {
          name: 'FeedType',
          type: 'Array&lt;any&gt;'
        },
        "Url": {
          name: 'Url',
          type: 'string'
        },
        "Description": {
          name: 'Description',
          type: 'string'
        },
        "Username": {
          name: 'Username',
          type: 'string'
        },
        "Password": {
          name: 'Password',
          type: 'string'
        },
        "UpdateInterval": {
          name: 'UpdateInterval',
          type: 'number',
          default: 900
        },
        "GetPreviousTime": {
          name: 'GetPreviousTime',
          type: 'number',
          default: 10800
        },
        "GetPreviousItems": {
          name: 'GetPreviousItems',
          type: 'number',
          default: 25
        },
        "Metadata": {
          name: 'Metadata',
          type: 'any'
        },
        "libraryId": {
          name: 'libraryId',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        library: {
          name: 'library',
          type: 'Library',
          model: 'Library',
          relationType: 'belongsTo',
                  keyFrom: 'libraryId',
          keyTo: 'id'
        },
        tags: {
          name: 'tags',
          type: 'Tag[]',
          model: 'Tag',
          relationType: 'hasMany',
          modelThrough: 'TagFeed',
          keyThrough: 'tagId',
          keyFrom: 'id',
          keyTo: 'feedId'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Feed.ts